export interface PaymentMethod {
  id: string;
  customerId: string;
  paymentMethodId: string;
  provider: string;
  isDeletable: boolean;
  card?: PaymentMethodCard;
}

export interface PaymentMethodCard {
  brand: string;
  last4: string;
  expMonth: number;
  expYear: number;
  isDefault: boolean;
  isActive: boolean;
}

export interface PaymentMethods {
  items: PaymentMethod[];
  totalCount?: number;
  estimatedTotalCount?: number;
}

export interface PaymentMethodSetup {
  customerId: string;
  setupId: string;
  clientSecret: string;
}

export const formatPaymentMethodBrand = (brand?: string): string => {
  if (!brand) {
    return 'Card';
  }

  if (brand.toLowerCase() === 'amex') {
    return 'American Express';
  }

  return brand.charAt(0).toUpperCase() + brand.slice(1);
};

export const formatPaymentMethodExpiry = (expMonth?: number, expYear?: number): string | null => {
  if (!expMonth || !expYear) {
    return null;
  }

  const month = expMonth.toString().padStart(2, '0');
  const year = (expYear % 100).toString().padStart(2, '0');
  return `${month}/${year}`;
};
